export const CARA_WIDGET_HOST = 'widget';
export const CARA_BM_HEADER_HOST = 'bm-header';
export const CARA_OPEN_REQUEST_EVENT = 'caraOpenRequest';
//# sourceMappingURL=cara.js.map